import { PassioClient, ProxyAuth } from "@passio/api-client";
import { EasyAIClient } from "@passio/easyai-client";
import { pushCall } from "./calls";
import { getClientHeaders } from "./clientSettings";
import { getRouteModel, trackServedModel } from "./models";
import { trackingFetch } from "./usage";

/**
 * The browser never sees API keys: both clients talk to the demo server's proxy, which
 * injects credentials, enforces limits and forwards the live usage headers.
 */
export const passio = new PassioClient({
  baseUrl: "/proxy/passio",
  auth: new ProxyAuth(),
  headers: getClientHeaders,
  model: getRouteModel,
  fetch: trackingFetch,
  timeoutMs: 300_000,
  onCall: (r) => {
    pushCall(r);
    trackServedModel(r);
  },
});

export const easyai = new EasyAIClient({ baseUrl: "/proxy/easyai", credentials: "same-origin", fetch: trackingFetch, onCall: pushCall });

let publicApiHost = "api.passiolife.com";
let publicEasyAiOrigin = "https://easyai.passiolife.com";

/** The EasyAI instance this deployment proxies to (from `/api/me`), for chain code snippets. */
export const setPublicEasyAiOrigin = (origin: string) => void (publicEasyAiOrigin = origin || publicEasyAiOrigin);
export const easyAiOrigin = () => publicEasyAiOrigin;

/** The API host this deployment proxies to (from `/api/me`), so code snippets target the same environment. */
export const setPublicApiHost = (host: string) => void (publicApiHost = host || publicApiHost);
export const publicApiOrigin = () => `https://${publicApiHost}`;
/** Where the same call goes when made directly against the API (for code snippets). */
export const publicApiBase = () => `${publicApiOrigin()}/v2/products`;
